<script lang="ts">
  import { getContext } from "svelte";
  import { errorComponent, navigatorOptions } from "@kestrel/internal/client";
  import { getComponentByIslandId } from "../islands/islands.js";
  import type { KestrelStores } from "@kestrel/stores";
  import type { RootProps } from "./root.types.js";
  import { clientContext } from "../stores/index-universal.js";

  const { component, island = "default" }: RootProps = $props();
  const { data, form, error, component: componentStore } = getContext<KestrelStores>(clientContext);
  let Component = $state(component);

  if (!import.meta.env.SSR) {
    /*                                                                */
    /*                     */
    componentStore.subscribe((resolvedComponent) => {
      /*                                                                      */
      const islandComponent = getComponentByIslandId(island, resolvedComponent);

      /*                                                    */
      if (Component === islandComponent) return;
      Component = islandComponent;
    });
  }

  /*                                                   */
  const errorToString = (err: unknown): string =>
    typeof err === "string" ? err : `${err instanceof Error ? err.stack : err}`;
</script>

{#snippet renderIsland()}
  {#if $error}
    <!-- This means, the error component will never be rendered on the server -->
    {#await errorComponent() then { default: ErrorComponent }}
      <ErrorComponent error={$error} />
    {/await}
  {:else if Component}
    <Component data={$data} form={$form} />
  {/if}
{/snippet}

{#if import.meta.env.DEV}
  <!-- In dev mode throw all errors -->
  {@render renderIsland()}
{:else}
  <!-- In production mode, catch errors and render a boundary -->
  <svelte:boundary>
    {@render renderIsland()}

    {#snippet failed(error)}
      {@html `<!-- Could not render island "${island}": ${errorToString(error)} -->`}
    {/snippet}
  </svelte:boundary>
{/if}

<!-- If Global Navigator is Enabled, load Navigator Component -->
{#if navigatorOptions}
  {#await import("./navigator.svelte") then { default: Navigator }}
    <Navigator {navigatorOptions} />
  {/await}
{/if}
